import axios from 'axios';

import { createToast, toastType } from 'Common/ToastHelper';
import * as ConnectionActions from 'State/connection/actions';
import * as ConnectionSelectors from 'State/connection/selectors';
import { isRequestCancelation } from 'Common/Helpers';

export const RegisterUnauthorizedInteceptors = (function() {
  /**
   * keeps track of an ongoing toast, to reduce duplicates
   */
  let toastId = null;

  return function() {
    /**
     * Register global axios interceptors
     */
    axios.interceptors.response.use(
      response => {
        //do something with response data
        return Promise.resolve(response);
      },
      error => {
        let errorText = '',
          { response = {} } = error,
          { status: responseStatus } = response;

        switch (responseStatus) {
          case 500:
            errorText = 'A server error has occurred.';
            break;
          case 401:
            if (
              typeof error.response.data === 'string' &&
              error.response.data.includes('inactivity')
            ) {
              errorText = error.response.data;
            } else {
              errorText =
                'You do not have the proper permissions to access this resource.';
            }
            break;
          case 403:
            errorText =
              'Your IP address is now outside the set range, please log out.';
            break;
          default:
            return Promise.reject(error);
        }
        //prevent pages with multiple api calls from creating multiple notifications
        if (!toastId) {
          toastId = createToast(
            toastType.error,
            'Error',
            errorText,
            true,
            undefined,
            () => {
              toastId = null;
            }
          );
        }

        return Promise.reject(error);
      }
    );
  };
})();

export const RegisterConnectionStatusInterceptors = (function() {
  return function(store) {
    axios.interceptors.response.use(
      // When the request is ok check that serverUp is true, if it's not set it to true.
      response => {
        if (store) {
          const serverUp = ConnectionSelectors.getServerUp(store.getState());
          if (!serverUp) {
            store.dispatch(ConnectionActions.setServerUp(true));
            store.dispatch(ConnectionActions.hideOfflinePrompt());
          }
        }
        //do something with response data
        return Promise.resolve(response);
      },
      // When the request is having a problem, we may want to set serverUp to false and show a dialog.
      error => {
        if (store) {
          const state = store.getState();
          const serverUp = ConnectionSelectors.getServerUp(state);
          const offlineMode = ConnectionSelectors.getOfflineMode(state)
          const { response = {} } = error;
          const { status: responseStatus } = response;

          if (
            !isRequestCancelation(error) &&
            !error.response &&
            serverUp &&
            responseStatus !== 401
          ) {
            if (serverUp) {
              store.dispatch(ConnectionActions.setServerUp(false));
            }

            //only prompt to go to offline mode if the app is not currenlty in offline mode
            if(!offlineMode){
              store.dispatch(ConnectionActions.showOfflinePrompt());
            }

          }
        }
        return Promise.reject(error);
      }
    );
  };
})();



// WEBPACK FOOTER //
// ./src/api/Interceptors.js